import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useMemo } from 'react';
import { Grid, TextField as MuiTextField, styled } from '@mui/material';
const NoWrapSpan = styled('span') `
  white-space: nowrap;
`;
export const TextField = ({ characterLimit, showCharacterCount, helperText: helperTextArg, onChange: onChangeCallback, ...args }) => {
    const [characterCount, setCharacterCount] = React.useState(args.value?.length ?? 0);
    const [value, setValue] = React.useState(args.value);
    useEffect(() => {
        if (args.value !== value) {
            setValue(args.value);
        }
    }, [args.value]);
    const onChange = (event) => {
        const newCharacterCount = event.target.value.length;
        if (characterLimit) {
            if (newCharacterCount > characterLimit)
                return;
            setCharacterCount(event.target.value.length);
        }
        ;
        setValue(event.target.value);
        onChangeCallback?.(event);
    };
    const helperText = useMemo(() => {
        if (showCharacterCount && characterLimit) {
            return (_jsxs(Grid, { container: true, direction: 'row', justifyContent: 'space-between', flexWrap: 'nowrap', columnGap: 0.5, children: [_jsx("span", { children: helperTextArg }), _jsx(NoWrapSpan, { children: `${characterCount}/${characterLimit}` })] }));
        }
        else
            return helperTextArg;
    }, [characterCount, characterLimit, helperTextArg, showCharacterCount]);
    return _jsx(MuiTextField, { onChange: onChange, ...args, helperText: helperText, value: value });
};
//# sourceMappingURL=index.js.map